import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { styled } from '../../../core/theme/styled';

export const BorderContainer = styled(Box)`
  border: 1px solid ${(props) => props.theme.configuration.strokeColor};
  border-radius: ${(props) => props.theme.roundedCorners.small};
  background-color: ${(props) => props.theme.configuration.backgroundColor};
`;

export const SolidContainer = styled(BorderContainer)`
  background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
  border: none;
`;
